<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="order-detail custom-form">
        <div class="list-status">
          <div class="list-carInfo">
            <div class="top-company">
              <div class="top-company-label">服</div>
<!--              <el-image :src="detailImage" class="company-image"></el-image>-->
              <div class="company-right">
                <div class="right-1">{{ detail.companyName }}</div>
                <div class="right-2">
                  <div>公司ID：{{ detail.companyId }}</div>
<!--                  <span class="line">|</span>-->
                  <div>
                    公司地址：{{ detail.provinceName }}{{ detail.cityName }}{{ detail.districtName }}{{ detail.address }}
                  </div>
                </div>
              </div>
            </div>
            <div class="title-box">
              <el-image :src="cheImage" class="title-label"></el-image>
              超管账号信息
            </div>
            <el-row class="content-info-box">
              <el-col :span="12">
                <span class="label">负责人：</span>
                <span class="value">{{ detail.adminUsername }}</span>
              </el-col>
              <el-col :span="12">
                <span class="label">手机号码：</span>
                <span class="value">{{ detail.adminPhone }}</span>
              </el-col>
              <el-col :span="12">
                <span class="label">超管账号：</span>
                <span class="value">{{ detail.adminAccount }}</span>
              </el-col>
            </el-row>
            <div class="title-box">
              <el-image :src="cheImage" class="title-label"></el-image>
              财务信息
            </div>
            <el-row class="content-info-box">
              <el-col :span="12">
                <span class="label">充值方式：</span>
                <span class="value" v-if="detail.rechargeMethod === 1">预充值</span>
                <span class="value" v-if="detail.rechargeMethod === 2">后付款</span>
              </el-col>
              <el-col :span="12">
                <span class="label">是否有开票资质：</span>
                <span class="value">{{ detail.invoiceQualification?'是':'否' }}</span>
              </el-col>
            </el-row>
            <div class="title-box" v-if="detail.attachments && detail.attachments.length > 0">
              <el-image :src="cheImage" class="title-label"></el-image>
              附件信息
            </div>
            <div class="content-info-box">
              <div
                class="color526bec file-view"
                @click="turnTo(item)"
                v-for="item in detail.attachments"
                :key="item.fileId">
                {{item.filename}}
              </div>
            </div>
            <div class="title-box">
              <el-image :src="cheImage" class="title-label"></el-image>
              公司创建信息
            </div>
            <el-row class="content-info-box">
              <el-col :span="12">
                <span class="label">创建人：</span>
                <span class="value">{{ detail.createUsername }}</span>
              </el-col>
              <el-col :span="12">
                <span class="label">创建日期：</span>
                <span class="value">{{ detail.createTime }}</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </template>
  </DialogContainer>
</template>
<script>
import DialogContainer from "@/components/Dialog.vue";
import { detailInfo } from "./api";

export default {
  name: "Detail",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "详情",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      detailImage: require("@/assets/imgs/company.png"),
      cheImage: require("@/assets/imgs/title.png"),
      detail: {},
    };
  },
  methods: {
    turnTo(row) {
      window.open(this.getShortImageToken(row.fileId), "_blank");
    },
    getShortImageToken(fileId) {
      let url =
          process.env.VUE_APP_BASE_PATH +
          process.env.VUE_APP_REMOTE_API +
          "/pmy/file/sys-file/download?fileId=" +
          fileId;
      return url;
    },
    init(row) {
      this.getDetail(row.companyId);
      this.dialogObj.show = true;
    },
    getDetail(companyId) {
      detailInfo(companyId).then((res) => {
        if (res.code === 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.order-detail {
  .list-box {
    background: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
    .list-bottom {
      width: 100%;
      display: flex;
      padding: 0.08rem 0;
      .list-bottom-box {
        width: 15%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .list-image {
          width: 0.85rem;
          height: 0.5rem;
          border-radius: 0.05rem;
        }
        .bottom-box-name {
          color: #8c8c8c;
          font-size: 0.12rem;
          margin-bottom: 0.06rem;
        }
        .bottom-box-value {
          color: #434343;
          font-size: 0.14rem;
        }
      }
      .list-bottom-box2 {
        width: 20%;
      }
      .list-bottom-box::before {
        content: "";
        position: absolute;
        right: 0;
        top: 0.08rem;
        width: 0.01rem;
        height: 0.26rem;
        background-color: #dce5f5;
      }
      .list-bottom-box:nth-last-of-type(1)::before {
        display: none;
      }
    }
    .list-bottom2 {
      .list-bottom-box:nth-last-of-type(1):before,
      .list-bottom-box:nth-last-of-type(2):before,
      .list-bottom-box:nth-last-of-type(3):before,
      .list-bottom-box:nth-last-of-type(4):before {
        display: none;
      }
    }
  }
  .list-status {
    display: flex;
    .title-box {
      padding: 0.2rem 0 0;
      .title-label {
        width: 0.08rem;
        height: 0.08rem;
        margin-right: 0.06rem;
      }
    }
    .list-step {
      width: 25%;
    }
    .list-carInfo {
      width: 100%;
    }
    .list-label {
      padding: 0.1rem 0;
    }
    //.list-step-box {
    //  display: flex;
    //  flex-direction: column;
    //  padding: 0 0.3rem 0 0.5rem;
    //  box-sizing: border-box;
    //  .step-list {
    //    border-radius: 0.1rem;
    //    background: #ffffff;
    //    padding: 0.04rem 0.14rem;
    //    box-sizing: border-box;
    //    margin-bottom: 0.5rem;
    //    position: relative;
    //    .step-date {
    //      font-size: 0.12rem;
    //      height: 0.22rem;
    //    }
    //    .step-content {
    //      font-size: 0.14rem;
    //    }
    //  }
    //  .step-list::before {
    //    content: "";
    //    position: absolute;
    //  }
    //}
    .color8c8c8c {
      color: #8c8c8c;
    }
    .color434343 {
      color: #434343;
    }
    .bgEDF4FF {
      background-color: #edf4ff;
    }
  }
  .content-info-box {
    padding-top: 0.08rem;
    div {
      padding-top: 0.1rem;
    }
  }
  .top-company {
    display: flex;
    align-items: center;
    background-color: #f7fbff;
    padding: 0.1rem;
    box-sizing: border-box;
    border-radius: 0.08rem;
    .top-company-label{
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      font-size: 0.22rem;
      background-color: rgba(30, 99, 221, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .company-image {
      width: 0.6rem;
      height: 0.6rem;
    }
    .company-right {
      padding-left: 0.1rem;
      .right-1 {
        font-size: 0.18rem;
        color: #000000;
        line-height: 0.2rem;
      }
      .right-2 {
        color: #8c8c8c;
        font-size: 0.14rem;
        line-height: 0.2rem;
        padding-top: 0.06rem;
        .line {
          margin: 0 0.06rem;
        }
      }
    }
  } .file-view{
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
}
</style>
